module.exports = __webpack_public_path__ + "92966cabc1dec3778c6425f46a26a1fb.MP3";